import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import reduxThunk from 'redux-thunk';

import mapReducer from './store/reducers/mapReducer';
import statsReducer from './store/reducers/statsReducer';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const logger = store =>  next =>  action => {
	//console.log("Logger Dispatching action", action);
	const result = next(action);
//	console.log("Logger State", store.getState());
	return result;
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
	mapReducer, statsReducer
})

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(logger, reduxThunk)));

const app = (
		<Provider store={store}>
			<BrowserRouter>
		        <App />
		    </BrowserRouter>
		</Provider>    
	)

ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js